import React from 'react';
import PropTypes from 'prop-types';
import _noop from 'lodash/noop';
import List from '../list';
import VideoCard from '../video-card';

const SearchResults = ({
    searchQuery = '',
    searchResults = [],
    hideButton = true,
    buttonClickHandler,
    basePath,
    onItemClick,
    videoCardType,
    lang,
    searchResultLabel,
}) => (
    <div className="search-results">
        <h1 className="search-results__title">{searchResultLabel} {searchQuery}</h1>
        <List
            listItems={searchResults}
            hideButton={hideButton}
            buttonClickHandler={buttonClickHandler}
            className="search-results__list"
            itemsBasePath={basePath}
            videoCardType={videoCardType}
            onItemClick={onItemClick}
            lang={lang}
        />
    </div>
);

SearchResults.propTypes = {
    basePath: PropTypes.string.isRequired,
    searchQuery: PropTypes.string,
    searchResults: PropTypes.arrayOf(PropTypes.object),
    hideButton: PropTypes.bool,
    buttonClickHandler: PropTypes.func,
    onItemClick: PropTypes.func,
    videoCardType: PropTypes.string,
    searchResultLabel: PropTypes.string,
};

SearchResults.defaultProps = {
    searchQuery: '',
    searchResults: [],
    hideButton: true,
    buttonClickHandler: _noop,
    onItemClick: _noop,
    videoCardType: VideoCard.types.LANDSCAPE,
    lang: 'en',
    searchResultLabel: 'Search Results for',
};

export default SearchResults;
